module.exports = __webpack_public_path__ + "img/center-details-data5.6b5cbb3b.png";